/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-website': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<g transform="translate(.978 7.978) scale(.25077)"><path pid="0" class="st0" d="M0 0v56h56V0z" _fill="#000" fill-opacity="1" stroke-width="1.001" stroke-miterlimit="4" stroke-dasharray="none"/><path pid="1" class="st0" d="M13.047 30.353c.895-1.112 2.238-1.56 3.58-1.343 1.56.217 2.903 1.113 4.015 2.455l1.56 1.79 1.79-1.56c2.903-2.006 6.483-2.902 10.05-2.685 3.133 0 6.483.665 9.155 2.238v6.93h4.462V17.836h-4.693v8.26c-2.902-1.113-6.035-1.79-9.154-1.79-4.015-.218-7.812.664-11.393 2.454-1.56-1.56-3.797-2.455-6.035-2.455-1.112 0-2.455.217-3.35.665V17.82H8.34v20.317h4.693v-7.785z" _fill="#fff" fill-opacity="1" stroke-width="1.356"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-website.js